import React from "react"
import NavLink from "./NavLink"
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../../hooks/UseStores"
import {URLPATHS} from "../../../utils/utils"
import "../index.scss"
import {AvailableApps} from "./AvailableApps/AvailableApps"

const NavBar = () => {
  const {navStore, insightStore, locGroupStore, disStore, gtMapStore} = UseStores()

  const routes = [
    {
      path: "/brands/discovery",
      sidebarName: "Brands",
      isDisabled: false,
    },
    {
      path: "/insights",
      sidebarName: "Brand Insights",
      isDisabled: false,
    },
    {
      path: "/locationgroups",
      sidebarName: "Location Groups",
      isDisabled: false,
    },
  ]

  const handleOnClick = () => {
    insightStore.setInsightType("Market Share")
    insightStore.setBrandId(25)
    insightStore.setInsightMarketType("National")
    insightStore.setInsightMarketTypeValue([0])
    navStore.setSideNavToggle(false)
    navStore.setPreviousPage(window.location.pathname)

    if (window.location.pathname === URLPATHS.LGLOCATIONS) {
      locGroupStore.updateMapGeoRequest() //update requestIds before updating map component
      locGroupStore.setLocGeoTime({geo: locGroupStore.geoNonePOI})
      gtMapStore.setMapObj({
        geo: locGroupStore.geoNonePOI,
        locationGroupId: locGroupStore.tagId,
        mapGeos: locGroupStore.mapGeos,
      })
    } else if (window.location.pathname === URLPATHS.BRANDSLOCATIONS) {
      disStore.setGeoTimeObj({geo: disStore.geoNonePOI})
      gtMapStore.setMapObj({
        geo: disStore.geoNonePOI,
        brandId: disStore.brandId,
        categoryId: disStore.sicCode,
      })
    }
  }

  const linkStyle = {color: "#FFF"}

  return (
    <div data-testid="sidebar-test">
      <Drawer
        open={navStore.sideNavToggle}
        onClose={() => navStore.setSideNavToggle(false)}
        className="sidebar-drawer"
      >
        <div role="presentation">
          <List>
            {routes.map((route) => {
              return (
                <React.Fragment key={route.path}>
                  {route.isDisabled ? (
                    <ListItem
                      role="list"
                      button
                      key={route.sidebarName}
                      disableTouchRipple={true}
                      disabled={route.isDisabled}
                      onClick={() => handleOnClick()}
                    >
                      <ListItemText primary={route.sidebarName} role="list-item-route" />
                    </ListItem>
                  ) : (
                    <NavLink to={route.path} style={linkStyle} role="link">
                      <ListItem
                        role="list"
                        button
                        key={route.sidebarName}
                        disableTouchRipple={true}
                        onClick={() => handleOnClick()}
                      >
                        <ListItemText
                          primary={route.sidebarName}
                          role="list-item-route"
                        />
                      </ListItem>
                    </NavLink>
                  )}
                </React.Fragment>
              )
            })}
            <ListItem className="available-apps-title">
              <div id="availableApps-btn">Available Apps</div>
            </ListItem>
          </List>
        </div>
        <div className="available-apps-wrapper">
          <AvailableApps />
        </div>
      </Drawer>
    </div>
  )
}
export default observer(NavBar)
